import { render, staticRenderFns } from "./Expandable.vue?vue&type=template&id=366ca278"
import script from "./Expandable.vue?vue&type=script&lang=js"
export * from "./Expandable.vue?vue&type=script&lang=js"
import style0 from "./Expandable.vue?vue&type=style&index=0&id=366ca278&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports